import { useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import styled from '@emotion/styled'

import PhotoThumb from './PhotoThumb'

const StyledSwiper = styled(Swiper)`
  ${({ theme }) => `
    .swiper-wrapper {
      margin-left: ${theme.spacing(4)};
    }

    .swiper-slide {
      width: 58px;
    }
  `}
`

const HorizontalPhotoSlides = ({ photos, photoUrlId, setPhotoUrlId }) => {
  const [swiper, setSwiper] = useState(null)

  useEffect(() => {
    if (!swiper) {
      return
    }
    const index = photos?.findIndex((photo) => photo.urlId === photoUrlId)
    if (index > -1 && swiper?.realIndex !== index) {
      swiper.slideTo(index)
    }
  }, [photos, photoUrlId, swiper])

  return (
    <StyledSwiper
      slidesPerView="auto"
      spaceBetween={8}
      onAfterInit={(swiper) => setSwiper(swiper)}
    >
      {photos?.map((photo) => (
        <SwiperSlide key={photo._id}>
          <PhotoThumb
            photo={photo}
            isSelected={photoUrlId === photo.urlId}
            onClick={() => setPhotoUrlId(photo.urlId)}
          />
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}

HorizontalPhotoSlides.defaultProps = {
  photos: [],
}

export default HorizontalPhotoSlides
